export function parseApiErrorMessage(message: string): string {
    try {
        const match = message.match(/{.*}/);
        if (match) {
            const parsed = JSON.parse(match[0]);
            if (parsed.detail) return parsed.detail;
        }
        return message;
    } catch {
        return message;
    }
}